import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {getSouscriptionToModifySaga, modificationSouscriptionSaga,} from "./modificationSouscriptionSaga";

export default function* modificationSouscriptionWatcher() {
  yield takeLatest(
    ActionsTypes.MODIFICATION_SOUSCRIPTION,
    modificationSouscriptionSaga
  );
  yield takeLatest(
    ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY,
    getSouscriptionToModifySaga
  );
}
